import { useState, useCallback } from 'react';

interface ErrorBannerState {
  error: string | null;
  type: 'error' | 'warning' | 'info';
}

export const useErrorBanner = () => {
  const [bannerState, setBannerState] = useState<ErrorBannerState>({
    error: null,
    type: 'error',
  });

  const showError = useCallback((message: string) => {
    setBannerState({ error: message, type: 'error' });
  }, []);

  const showWarning = useCallback((message: string) => {
    setBannerState({ error: message, type: 'warning' });
  }, []);

  const showInfo = useCallback((message: string) => {
    setBannerState({ error: message, type: 'info' });
  }, []);

  const clearError = useCallback(() => {
    setBannerState({ error: null, type: 'error' });
  }, []);

  return {
    error: bannerState.error,
    errorType: bannerState.type,
    showError,
    showWarning,
    showInfo,
    clearError,
  };
};
